var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home",on:{"click":function($event){return _vm.navigateTo('collection')}}},[_c('LogoComponent',{staticClass:"home__svg"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }